export default "<div class=\"container\">\n    <app-about-custom></app-about-custom>\n</div>\n"